export const environment = {
  production: true,
  connection: {
    name: 'Hagebau Bolay intern Softline',
    // https://softline.intern.hagebau-bolay.de
    host: location.protocol + '//' + location.hostname,
    port: Number(location.port) ?? 443,
    basePath: '/api',
  },
  androidUpdateRepository: '',
};
